import type { AddressCreation } from '@/types/external/2work/doctypes/generatorOutput/Contacts/AddressCreation'
import type { AddressDynamic } from '@/types/external/2work/doctypes/generatorOutput/Contacts/AddressDynamic'

type Enum<E> = Record<keyof E, number | string> & Record<number, string>
// assertion functions needs type definition first to be used as arrow function!
type RequireExistanceAssertionFunction = <ObjectType>(
  requireObject: ObjectType,
  objectName: string,
) => asserts requireObject is NonNullable<ObjectType>

// assertion functions needs type definition first to be used as arrow function!
const requireExistance: RequireExistanceAssertionFunction = (requireObject, objectName) => {
  if (requireObject === null || requireObject === undefined) {
    const errorMessagePrefix = 'missing require object: '

    throw new Error(errorMessagePrefix + objectName)
  }
}

const isInput = (element: EventTarget | null): element is HTMLInputElement => {
  return element instanceof HTMLInputElement
}

const isSelect = (element: EventTarget | null): element is HTMLSelectElement => {
  return element instanceof HTMLSelectElement
}

const isAddressCreationType = (object: AddressDynamic): object is AddressCreation => {
  const line1 = !!object.address_line1
  const type = !!object.address_type
  const city = !!object.city
  const country = !!object.country

  return line1 && type && city && country
}

// TODO: build this without eslint ignore TOWORK-349
const validateStringAgainstEnum = <E extends Enum<E>>(
  enumObj: E,
  value: string,
): E[keyof E] | undefined => {
  for (const key in enumObj) {
    if (Object.hasOwn(enumObj, key)) {
      // Check if the value matches the enum key or value

      if (enumObj[key] === value || key === value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return enumObj[key as keyof E]
      }
    }
  }

  // Return undefined if no match is found
  // eslint-disable-next-line @typescript-eslint/consistent-return
  return undefined
}

// TODO: rewrite this TOWORK-349
type Entries<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][]
const getEntries = <T extends object>(obj: T): Entries<T> => {
  // DO NOT DO THIS! (do not use type casting for typeguard)
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return Object.entries(obj) as Entries<T>
}

export {
  type Entries,
  getEntries,
  isAddressCreationType,
  isInput,
  isSelect,
  requireExistance,
  validateStringAgainstEnum,
}
